import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INDUSTRIES } from "../data/site";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { CtaBlock } from "./About";

export default function Industries() {
  return (
    <>
      <PageHero
        eyebrow="Industries"
        title={<>Where <span className="text-[var(--primary)]">UMD</span><br/>delivers.</>}
        subtitle="Nine critical industries trust UMD to design, build and sustain the engineering systems they cannot afford to fail."
        image="https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=1920&q=80"
      />

      <section className="py-24 md:py-32 container-wide">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.name} delay={i * 60}>
              <Link to="/contact" data-testid={`industry-card-${ind.name.toLowerCase().replace(/\s+/g, "-")}`} className="proj-card block aspect-[4/5] relative group">
                <img src={ind.image} alt={ind.name} className="absolute inset-0 w-full h-full object-cover" />
                <div className="proj-mask absolute inset-0" />
                <div className="absolute top-5 left-5 font-mono-tech text-[10px] tracking-[0.25em] uppercase text-white/70">0{i + 1}</div>
                <div className="absolute bottom-6 left-6 right-6 text-white">
                  <h3 className="font-display text-2xl md:text-3xl leading-tight tracking-tight">{ind.name}</h3>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-xs text-white/60 font-mono-tech tracking-wider">{ind.count}</span>
                    <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBlock />
    </>
  );
}
